import { Radio } from '@cast/design-system';
import { PolicyAutoscalerMode } from '@cast/types';

import { minimumWoopAgentVersionForDeferredMode } from 'features/cluster/workload-optimization/_constants';
import { useVersionsInfo } from 'features/cluster/workload-optimization/_hooks/useVersionsInfo';

import { InputPairContainer } from '../InputPairContainer';
import { PolicyCardForm } from './_components/PolicyCardForm';
import { WarningTooltip } from '../../../_components/WarningTooltip';
import { vpaSettingsConstants } from '../../_constants/settingsConstants';

import { RffRadioGroup } from '@cast/shared-rff-ui';

type WhenToApplyFieldProps = {
  name: string;
  showTooltip?: boolean;
};

export const WhenToApplyField = ({
  name,
  showTooltip = false,
}: WhenToApplyFieldProps) => {
  const { isDeferredModeCannotBeUsed } = useVersionsInfo();

  return (
    <RffRadioGroup name={name}>
      <InputPairContainer data-testid="applyType-field">
        <PolicyCardForm
          control={
            <Radio
              testId="immediate"
              value={PolicyAutoscalerMode.IMMEDIATE}
              size="small"
            />
          }
          label="Immediately"
          description={
            !showTooltip
              ? vpaSettingsConstants.autoscaler.immediatelyTooltip
              : null
          }
          tooltipText={
            showTooltip
              ? vpaSettingsConstants.autoscaler.immediatelyTooltip
              : null
          }
        />

        <WarningTooltip
          title={`Deferred autoscaler mode not available if the workload-autoscaler component’s version is under ${minimumWoopAgentVersionForDeferredMode
            .replace('v', '')
            // Don't show trailing minor version if it is zero
            .replace(/\.0$/, '')}`}
          show={isDeferredModeCannotBeUsed}
        >
          <div>
            <PolicyCardForm
              control={
                <Radio
                  testId="deferred"
                  value={PolicyAutoscalerMode.DEFERRED}
                  size="small"
                  disabled={isDeferredModeCannotBeUsed || undefined}
                />
              }
              label="Deferred"
              description={
                !showTooltip
                  ? vpaSettingsConstants.autoscaler.deferredTooltip
                  : null
              }
              tooltipText={
                showTooltip
                  ? vpaSettingsConstants.autoscaler.deferredTooltip
                  : null
              }
            />
          </div>
        </WarningTooltip>
      </InputPairContainer>
    </RffRadioGroup>
  );
};
